const formsToSubmit = document.querySelectorAll(`[data-item="form"][data-submit="ajax-message"]`);
const section = document.querySelector(`[data-section="contact"]`);

if (formsToSubmit.length > 0) {
    formsToSubmit.forEach(form => {
        // Prevent default submit and handle it by self
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            // Get url from action attr
            let url = form.getAttribute("action");

            // Get all data from form
            let data = new FormData(form);

            let isValidate = true;
            // Validate form with default and custom validation
            let allInputs = form.querySelectorAll("input, textarea");
            allInputs.forEach(input => {
                let isInputValidate = false;
                isInputValidate = input.checkValidity();


                // If is not validate set attr that not every element is validate
                if (!isInputValidate) {
                    isValidate = false;
                }
            })

            // If validation is right, send it
            if (isValidate) {
                // Send it
                fetch(url, {
                    method: 'post',
                    body: data
                }).then(() => {
                    // After has been sent, show message
                    section.classList.add("status-sent");
                    // Clear form
                    form.reset();
                })
            }
        });

        // Add listeners to buttons that should close message that form has been sent
        let hideSent = section.querySelectorAll(`[data-item="close"]`);
        if (hideSent.length > 0) {
            hideSent.forEach(element => {
                element.addEventListener('click', () => {
                    section.classList.remove("status-sent");
                })
            });
        }
    })
}